module.exports = __webpack_public_path__ + "img/10.1fa752f1.png";